module.exports = __webpack_public_path__ + "static/FStext-c0b5bd7b74e60b9aaf36565d00209bb1.png";